<template>
  <div class="cadastrar-form">
    <breadcrumb :items="breadcrumbItems" />

    <div class="titulo-form">
      <h3>{{ verificarRota() }} Vaga</h3>
    </div>

    <form @submit.prevent="enviar()">
      <div class="form-layout">
        <div class="col-left">
          <FormField
            label="Título"
            id="titulo"
            required
            help-text="Informe o título da vaga"
          >
            <input
              id="titulo"
              type="text"
              class="field-input"
              v-model="form.titulo"
              placeholder="Informe o título da vaga"
              required
            />
          </FormField>

          <FormField
            label="Local da vaga"
            id="localVaga"
            required
            help-text="Informe o local onde a vaga será exercida"
          >
            <input
              id="localVaga"
              type="text"
              class="field-input"
              v-model="form.localVaga"
              placeholder="Ex: Campus Crateús, Remoto, etc."
              required
            />
          </FormField>

          <FormField
            label="Tipo de Vaga"
            required
            help-text="Informe se a vaga é agente, remunerada ou estágio"
          >
            <div class="tipo-vaga-container">
              <label
                class="tipo-vaga-option"
                :class="{
                  selected: !form.isBolsistaRemunerado && !form.isEstagiario,
                }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="VOLUNTARIA"
                  :checked="!form.isBolsistaRemunerado && !form.isEstagiario"
                  @change="setTipoVaga('VOLUNTARIA')"
                />
                <span class="radio-custom"></span>
                Agente
              </label>
              <label
                class="tipo-vaga-option"
                :class="{
                  selected: form.isBolsistaRemunerado && !form.isEstagiario,
                }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="REMUNERADA"
                  :checked="form.isBolsistaRemunerado && !form.isEstagiario"
                  @change="setTipoVaga('REMUNERADA')"
                />
                <span class="radio-custom"></span>
                Remunerada
              </label>
              <label
                class="tipo-vaga-option"
                :class="{ selected: form.isEstagiario }"
              >
                <input
                  type="radio"
                  name="tipoVaga"
                  value="ESTAGIO"
                  :checked="form.isEstagiario"
                  @change="setTipoVaga('ESTAGIO')"
                />
                <span class="radio-custom"></span>
                Estágio
              </label>
            </div>
          </FormField>

          <div id="datas">
            <FormField
              label="Data Inicial das Inscrições"
              id="dataInicio"
              required
              help-text="Data de início das inscrições para a vaga"
            >
              <input
                type="date"
                id="dataInicio"
                class="field-input"
                :min="dataMinima"
                v-model="form.dataInicioInscricao"
                required
              />
            </FormField>

            <FormField
              label="Data Final das Inscrições"
              id="dataFim"
              required
              help-text="Data de encerramento das inscrições para a vaga"
            >
              <input
                type="date"
                id="dataFim"
                class="field-input"
                :min="dataMinima"
                v-model="form.dataFimInscricao"
                required
              />
            </FormField>
          </div>

          <PalavrasChaveInput
            v-model="form.tags"
            label="Palavras-chave"
            :required="true"
            help-text="Informe as palavras-chave relacionadas à vaga"
          />

          <FormField
            label="Link para inscrição"
            id="linkInscricao"
            required
            help-text="Informe o link onde os candidatos podem se inscrever"
          >
            <input
              id="linkInscricao"
              type="url"
              class="field-input"
              v-model="form.linkInscricao"
              placeholder="https://exemplo.com/inscricao"
              required
            />
          </FormField>

          <FormField
            v-if="verificarRota() === 'Editar'"
            label="Status da vaga"
            id="status"
            help-text="Informe o status atual da vaga"
          >
            <select
              id="status"
              class="field-input"
              v-model="form.status"
            >
              <option value="ABERTA">Inscrições Abertas (ABERTA)</option>
              <option value="ENCERRADA">
                Inscrições Encerradas (ENCERRADA)
              </option>
              <option value="CANCELADA">Vaga Cancelada (CANCELADA)</option>
            </select>
          </FormField>

          <FormField
            label="Link para edital (Opcional)"
            id="linkEdital"
            help-text="Informe o link do edital da vaga"
          >
            <input
              id="linkEdital"
              type="url"
              class="field-input"
              v-model="form.linkEdital"
              placeholder="https://exemplo.com/edital.pdf"
            />
          </FormField>

          <imagemInput
            :imagem="form.imagem"
            @enviar-imagem="processarImagem"
            v-model="form.descricaoImagem"
          />
        </div>

        <div class="col-right">
          <EditorTextoInput
            v-model="form.textoInformativo"
            label="Texto informativo"
            id="textoInformativo"
            required
            help-text="Informe o texto informativo da vaga"
            group-class="full-height"
            :rows="15"
          />
        </div>
      </div>
      <div class="cadastro-form">
        <button
          type="submit"
          :disabled="carregando"
        >
          <div v-if="carregando">
            <carregamento :tipoCarregamento="'input'" />
          </div>
          <div v-else>
            {{ mensagemBotao() }}
          </div>
        </button>
      </div>
    </form>
  </div>
  <aviso
    v-if="mostrarModal"
    :texto="mensagemModal"
    :sucesso="sucessoModal"
    @fecharModal="fecharModalAviso"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { useVagas } from "@/composables/useVagas";
import FormField from "@/components/common/FormField.vue";
import imagemInput from "@/components/common/imagemInput.vue";
import PalavrasChaveInput from "@/components/common/PalavrasChaveInput.vue";
import EditorTextoInput from "@/components/common/EditorTextoInput.vue";
import Aviso from "@/components/common/aviso.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import { extrairTextoHtml } from "@/utils/FormatarEntradas";

const { fetchVagaById, saveVaga, updateVaga, isSaving } = useVagas();

const mostrarModal = ref(false);
const mensagemModal = ref("");
const sucessoModal = ref(false);
const hoje = new Date();
const dataMinima = ref(hoje.toISOString().split("T")[0]);

const route = useRoute();
const carregando = isSaving;

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id || form.value?.acaoId || form.value?.acao?.id;

  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "Vagas", to: `/acao/${acaoId}/vagas-acao` },
      {
        label: verificarRota() === "Editar" ? "Editar vaga" : "Cadastrar vaga",
        to: "",
      },
    ];
  }

  return [
    { label: "Início", to: "/" },
    { label: "Vagas", to: "/vagas" },
    {
      label: verificarRota() === "Editar" ? "Editar vaga" : "Cadastrar vaga",
      to: "",
    },
  ];
});

const form = ref({
  id: "",
  titulo: "",
  localVaga: "",
  isBolsistaRemunerado: false,
  isEstagiario: false,
  remunerada: false,
  tipoVaga: false,
  dataInicioInscricao: "",
  dataFimInscricao: "",
  tags: [],
  linkInscricao: "",
  linkEdital: "",
  textoInformativo: "",
  imagem: {
    mimeType: "",
    base64Data: "",
  },
  descricaoImagem: "",
  status: "ABERTA",
});

function processarImagem(imagem) {
  if (imagem) {
    form.value.imagem = {
      mimeType: imagem.mimeType,
      base64Data: imagem.base64Data,
    };
  } else {
    form.value.imagem = {
      mimeType: "",
      base64Data: "",
    };
    if (form.value.imagemUrl) {
      form.value.imagemUrl = null;
    }
    form.value.descricaoImagem = "";
  }
}

function setTipoVaga(tipo) {
  if (tipo === "REMUNERADA") {
    form.value.isBolsistaRemunerado = true;
    form.value.isEstagiario = false;
    form.value.remunerada = true;
    form.value.tipoVaga = "REMUNERADA";
  } else if (tipo === "ESTAGIO") {
    form.value.isBolsistaRemunerado = false;
    form.value.isEstagiario = true;
    form.value.remunerada = false;
    form.value.tipoVaga = "ESTAGIO";
  } else {
    form.value.isBolsistaRemunerado = false;
    form.value.isEstagiario = false;
    form.value.remunerada = false;
    form.value.tipoVaga = "VOLUNTARIA";
  }
}

function verificarRota() {
  return route.name === "editar-vaga" ? "Editar" : "Cadastrar";
}

function mensagemBotao() {
  return verificarRota() === "Editar" ? "Confirmar edição" : "Cadastrar vaga";
}

async function enviar() {
  // Validação de datas: dataInicioInscricao <= dataFimInscricao
  if (form.value.dataInicioInscricao && form.value.dataFimInscricao) {
    const dataInicio = new Date(form.value.dataInicioInscricao);
    const dataFim = new Date(form.value.dataFimInscricao);
    if (dataInicio > dataFim) {
      mostrarModalAviso(
        "A data de início das inscrições não pode ser posterior à data de fim.",
        false
      );
      return;
    }
  }

  // Validação de acessibilidade: descrição da imagem obrigatória se houver imagem carregada/selecionada
  const temImagem = Boolean(
    form.value.imagem?.base64Data ||
    (typeof form.value.imagem?.mimeType === "string" &&
      (form.value.imagem.mimeType.startsWith("http") ||
        form.value.imagem.mimeType.startsWith("data:"))) ||
    form.value.imagemUrl
  );

  if (temImagem && !form.value.descricaoImagem?.trim()) {
    mostrarModalAviso(
      "Por favor, informe a descrição da imagem para acessibilidade.",
      false
    );
    return;
  }

  const textoInformativoPuro = extrairTextoHtml(
    form.value.textoInformativo || ""
  ).trim();

  if (!textoInformativoPuro) {
    mostrarModalAviso("Por favor adicione um texto informativo à vaga", false);
    return;
  }

  if (!form.value.tags || form.value.tags.length === 0) {
    mostrarModalAviso(
      "Por favor adicione pelo menos uma palavra-chave à vaga",
      false
    );
    return;
  }

  try {
    const nomeRota = verificarRota();
    if (nomeRota === "Editar") {
      const response = await editarVaga();
      if (response) {
        mostrarModalAviso("Vaga editada com sucesso!", true);
      } else {
        mostrarModalAviso(
          "Ocorreu um erro ao editar a vaga. Por favor, tente novamente.",
          false
        );
      }
    } else {
      const response = await cadastrarVaga();
      if (response) {
        mostrarModalAviso("Vaga cadastrada com sucesso!", true);
      } else {
        mostrarModalAviso(
          "Ocorreu um erro ao cadastrar a vaga. Por favor, tente novamente.",
          false
        );
      }
    }
  } catch (error) {
    console.error("Erro ao processar a vaga:", error);
    mostrarModalAviso("Ocorreu um erro inesperado ao salvar a vaga.", false);
  }
}

async function cadastrarVaga() {
  const acaoId = route.params.id || form.value?.acaoId || form.value?.acao?.id;
  const payload = {
    ...form.value,
    isBolsistaRemunerado: form.value.isBolsistaRemunerado,
    isEstagiario: Boolean(form.value.isEstagiario),
    imagem: form.value.imagem?.base64Data ? { ...form.value.imagem } : null,
  };

  return await saveVaga(acaoId, payload);
}

async function editarVaga() {
  const payload = {
    ...form.value,
    isBolsistaRemunerado: form.value.isBolsistaRemunerado,
    isEstagiario: Boolean(form.value.isEstagiario),
    imagem: form.value.imagem?.base64Data ? { ...form.value.imagem } : null,
  };
  const vagaId = payload.id;

  return await updateVaga(vagaId, payload);
}

function mostrarModalAviso(mensagem, tipoSucesso = false) {
  mostrarModal.value = true;
  mensagemModal.value = mensagem;
  sucessoModal.value = tipoSucesso;
}

function fecharModalAviso() {
  mostrarModal.value = false;
  if (sucessoModal.value) {
    router.push(`/Vaga/${form.value.id}`);
  }
}

function parseDate(data) {
  if (!data) return "";
  return data.split("T")[0];
}

onMounted(async () => {
  const nomeRota = verificarRota();

  if (nomeRota === "Editar") {
    const vagaId = route.params.vagaId;

    const response = await fetchVagaById(vagaId);
    const vagaEncontrada = response?.data || response;
    form.value = vagaEncontrada;

    if (vagaEncontrada.imagemUrl) {
      form.value.imagem = {
        url: vagaEncontrada.imagemUrl,
        mimeType: vagaEncontrada.imagemUrl,
        base64Data: "",
      };
    }

    if (vagaEncontrada.isEstagiario) {
      setTipoVaga("ESTAGIO");
    } else if (vagaEncontrada.isBolsistaRemunerado) {
      setTipoVaga("REMUNERADA");
    } else {
      setTipoVaga("VOLUNTARIA");
    }

    if (form.value.dataInicioInscricao) {
      form.value.dataInicioInscricao = parseDate(
        form.value.dataInicioInscricao
      );
    }
    if (form.value.dataFimInscricao) {
      form.value.dataFimInscricao = parseDate(form.value.dataFimInscricao);
    }
    if (!form.value.tags) {
      form.value.tags = [];
    }
  }
});
</script>

<style scoped>
.cadastrar-form {
  min-height: 700px;
}

.tipo-vaga-container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  padding: 8px 0;
}

.tipo-vaga-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--preto, var(--cinza-escuro));
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tipo-vaga-option input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--cinza-claro);
  background-color: var(--branco);
  display: inline-block;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.1);
}

.tipo-vaga-option:hover .radio-custom {
  border-color: var(--roxo-claro, var(--roxo-medio));
}

.tipo-vaga-option input[type="radio"]:checked + .radio-custom {
  border-color: var(--roxo-claro, var(--roxo-medio));
  background-color: var(--branco);
}

.tipo-vaga-option input[type="radio"]:checked + .radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--roxo-claro, var(--roxo-medio));
  animation: radioPop 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.tipo-vaga-option.selected {
  color: var(--roxo-claro, var(--roxo-medio));
  font-weight: 600;
}

@keyframes radioPop {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

#datas {
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
}

#datas :deep(.field-group) {
  flex: 1;
  min-width: 0;
}

.cadastro-form > button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .tipo-vaga-container {
    flex-wrap: wrap;
    gap: 12px 20px;
  }
}
</style>
